/* eslint-disable complexity */
import {useDateTime} from '@hconnect/tuc-processes/fields/dateTime/useDateTime'
import {Box} from '@mui/material'
import moment from 'moment'
import React, {useCallback} from 'react'

import {RmcOrderIntakeStepType} from '../../../../../../orderIntake/config/stepTypes'
import {useStepValidationTrigger} from '../../../../../../orderIntake/validation/useStepValidation'

import {TimePicker} from './TimePicker'

/**
 * Component for the Time step
 * Handles delivery time selection for RMC orders
 * Redesigned to match mobile app implementation with slot management
 */
export const OrderProcessTimePickerStep: React.FC = () => {
  const {dateTime, setDateTime, businessHours} = useDateTime()
  const {triggerStepValidation} = useStepValidationTrigger(RmcOrderIntakeStepType.TIME)

  // Handle time selection - do NOT call onSuccess() immediately
  const handleTimeSelection = useCallback(
    async (selectedTime: moment.Moment) => {
      setDateTime([selectedTime])

      // Trigger validation after time selection
      await triggerStepValidation()

      // Do NOT call onSuccess() here - let the stepper's Continue button handle navigation
      // This allows users to review their selection before proceeding
    },
    [setDateTime, triggerStepValidation]
  )

  return (
    <Box
      data-test-id="time-step-content"
      sx={{
        backgroundColor: '#FFFFFF',
        borderRadius: '8px',
        display: 'flex',
        flexDirection: 'column',
        gap: '24px',
        minHeight: '400px'
      }}
    >
      {/* Main Content */}
      <Box sx={{flex: 1, display: 'flex', flexDirection: 'column', gap: '16px'}}>
        <TimePicker
          initialTime={dateTime && dateTime[0] ? moment(dateTime[0]) : moment()}
          minTime={businessHours?.earliestPossibleLoadTime ?? '00:00'}
          maxTime={businessHours?.latestPossibleLoadTime ?? '23:59'}
          onSelectedTimeChange={handleTimeSelection}
          testID="rmc-time-picker"
        />
      </Box>
    </Box>
  )
}
